import styled from 'styled-components';
import Box from 'components/Box';

/**
 * 1: Match the width of bold & non-bold text in the
 * label by increasing/decreasing letter-spacing slightly.
 * Prevents the label from getting visibly wider
 * or narrower as it's selected/unselected
 */

var LabelBox = styled(Box).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isChecked';
  }
}).withConfig({
  displayName: "LabelBox",
  componentId: "sc-ddr24r-0"
})(["", ""], function (p) {
  return p.isChecked ? "\n\t\tfont-weight: bold;\n\t\tletter-spacing: -0.0085em; /* 1 */\n\t" : "\n\t\tletter-spacing: 0.0085em; /* 1 */\n\t";
});
export default LabelBox;